// Vocabulário do cockpit de Coletas — compartilhado entre a página principal
// e a listagem de envios do dia. A ordem/semântica das situações espelha a
// classificação do zpl-checkout (primeira condição que casa vence).

/** Substatus do ML → rótulo humano. */
export const SUBSTATUS_ROTULO = {
    invoice_pending: 'Aguardando NF',
    pending: 'Pendente',
    buffered: 'Em espera',
    ready_to_print: 'Pronto p/ imprimir',
    ready_for_pickup: 'Pronto p/ coleta',
    printed: 'Etiqueta baixada',
    in_hub: 'No hub ML',
    out_for_delivery: 'Saiu p/ entrega',
    picked_up: 'Coletado',
    shipped: 'Enviado',
    delivered: 'Entregue',
};

/** Situação derivada do envio → rótulo (emoji do cockpit preservado de propósito). */
export const SITUACAO_ROTULO = {
    enviado: 'Enviado',
    fechado: '✔ Fechado',
    em_packing: 'Na bancada',
    impresso_no_lote: '🖨 Impresso no lote',
    impresso_sem_bip: 'Impresso s/ bip',
    impresso_via_zip: 'Impresso via ZIP',
    em_os: 'Em OS',
    aguardando_nf: '⏳ Aguardando NF',
    sem_etiqueta_ml: '🚫 Sem etiqueta ML',
    pronto_os: '✅ Pronto p/ OS',
    cancelado: 'Cancelado',
};

/** Situação → variante de Badge. */
export const SITUACAO_VARIANT = {
    enviado: 'success',
    fechado: 'success',
    em_packing: 'info',
    impresso_no_lote: 'info',
    impresso_sem_bip: 'warning',
    impresso_via_zip: 'info',
    em_os: 'info',
    aguardando_nf: 'warning',
    sem_etiqueta_ml: 'danger',
    pronto_os: 'default',
    cancelado: 'neutral',
};

/** Ordem de exibição dos badges de situação (mais "encerrado" primeiro). */
export const SITUACAO_ORDEM = [
    'enviado',
    'fechado',
    'em_packing',
    'impresso_no_lote',
    'impresso_sem_bip',
    'impresso_via_zip',
    'em_os',
    'pronto_os',
    'aguardando_nf',
    'sem_etiqueta_ml',
    'cancelado',
];

/**
 * 'YYYY-MM-DD' → Date LOCAL (meio-dia, imune a fuso). `new Date('YYYY-MM-DD')`
 * interpreta UTC e, em São Paulo, mostra o dia ANTERIOR — daí o parse manual.
 */
export function DiaIsoParaDate(dia) {
    const [ano, mes, diaDoMes] = String(dia || '').split('-').map(Number);
    return new Date(ano, (mes || 1) - 1, diaDoMes || 1, 12);
}

const FORMATO_DIA = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', weekday: 'short' });

/** '2026-09-02' → 'qua., 02 de set.' (rótulo curto do accordion). */
export function FormatarDiaCurto(dia) {
    if (!dia) return '—';
    return FORMATO_DIA.format(DiaIsoParaDate(dia));
}
